import { BaseError } from './base.js';
/** @deprecated */
export class DataLengthTooLongError extends BaseError {
  constructor(_ref) {
    let {
      consumed,
      length
    } = _ref;
    super("Consumed bytes (".concat(consumed, ") is shorter than data length (").concat(length - 1, ")."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'DataLengthTooLongError'
    });
  }
}
/** @deprecated */
export class DataLengthTooShortError extends BaseError {
  constructor(_ref2) {
    let {
      length,
      dataLength
    } = _ref2;
    super("Data length (".concat(dataLength - 1, ") is shorter than consumed bytes length (").concat(length - 1, ")."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'DataLengthTooShortError'
    });
  }
}
export class IntegerOutOfRangeError extends BaseError {
  constructor(_ref3) {
    let {
      max,
      min,
      signed,
      size,
      value
    } = _ref3;
    super("Number \"".concat(value, "\" is not in safe ").concat(size ? "".concat(size * 8, "-bit ").concat(signed ? 'signed' : 'unsigned', " ") : '', "integer range ").concat(max ? "(".concat(min, " to ").concat(max, ")") : "(above ".concat(min, ")")));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'IntegerOutOfRangeError'
    });
  }
}
export class InvalidBytesBooleanError extends BaseError {
  constructor(bytes) {
    super("Bytes value \"".concat(bytes, "\" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidBytesBooleanError'
    });
  }
}
export class InvalidHexBooleanError extends BaseError {
  constructor(hex) {
    super("Hex value \"".concat(hex, "\" is not a valid boolean. The hex value must be \"0x0\" (false) or \"0x1\" (true)."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidHexBooleanError'
    });
  }
}
export class InvalidHexValueError extends BaseError {
  constructor(value) {
    super("Hex value \"".concat(value, "\" is an odd length (").concat(value.length, "). It must be an even length."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidHexValueError'
    });
  }
}
/** @deprecated */
export class OffsetOutOfBoundsError extends BaseError {
  constructor(_ref4) {
    let {
      nextOffset,
      offset
    } = _ref4;
    super("Next offset (".concat(nextOffset, ") is greater than previous offset + consumed bytes (").concat(offset, ")"));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'OffsetOutOfBoundsError'
    });
  }
}
export class SizeOverflowError extends BaseError {
  constructor(_ref5) {
    let {
      givenSize,
      maxSize
    } = _ref5;
    super("Size cannot exceed ".concat(maxSize, " bytes. Given size: ").concat(givenSize, " bytes."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'SizeOverflowError'
    });
  }
}
//# sourceMappingURL=encoding.js.map